import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useAuthCheck = () => {
    const navigate = useNavigate();
    useEffect(() => {
        const stored = localStorage.getItem("bingold");

        if (stored) {
            try {
                const parsed = JSON.parse(stored);

                if (!parsed.token) {
                    localStorage.removeItem("bingold");
                    localStorage.removeItem("a13b_c9z_uid");
                    navigate("/login");
                }
            } catch (err) {
                console.error("Invalid bingold object", err);
                localStorage.removeItem("a13b_c9z_uid");
                localStorage.removeItem("bingold");
            }
        } 
    }, []);
};

export default useAuthCheck;
